__turbopack_context__.v({
  "className": "CNcVtW_className",
  "variable": "CNcVtW_variable",
});
